import React from 'react';
import { IconTrxLight } from '../../../../components/Icons';
import TransactionsModule from './TransactionsModule';
import { RightPanelModule } from '../../../components/NewTable/RightPanel/RightPanelContext';

/**
 * Transactions Module Configuration
 *
 * Defines the static properties of the Transactions module for the right panel
 */
const transactionsModuleConfig = {
  id: 'transactions',
  name: 'Transactions',
  icon: <IconTrxLight />,
  component: TransactionsModule,
  enabled: false,
  expandEnabled: false,
  keyboardShortcut: 't',
  order: 2,
};

export default transactionsModuleConfig;
